import React from 'react';
import {Helmet} from 'react-helmet';

const Error = () => {
    return (
		<div className="not-found">
			<p>404 Error!</p>
			<p>Page Not Found</p>
			<Helmet>
				<title>Page Not Found</title>
				<meta name="robots" content="noindex" />
				<meta name="googlebot" content="noindex" />
			</Helmet>
		</div>
    );
}
 
export default Error;


// WEBPACK FOOTER //
// ./src/components/pages/Error.js